
















import {Component, Prop, Vue} from 'vue-property-decorator';
import {swiper, swiperSlide} from 'vue-awesome-swiper';
import PartFive from './PartFive/PartFive.vue';
import MoreOne from './PartFive/MoreOne.vue';
import MoreTwo from './PartFive/MoreTwo.vue';
import MoreThree from './PartFive/MoreThree.vue';

@Component({
  components: {
    swiper,
    swiperSlide,
    PartFive,
    MoreOne,
    MoreTwo,
    MoreThree,
  },
})
export default class HomeThree extends Vue {

  get swiperOption() {
    return {
      autoHeight: true,
      direction: 'vertical',
      slidesPerView: 1,
      preloadImages: true,
      loop: false,
      effect: 'slide',
      touchReleaseOnEdges: true,
      navigation: {
        nextEl: '.swiper-part-more',
      },
    };
  }
}
